import collect from 'collect.js';
import { Server } from '../../../types/basket';
import { Client as ClientMenu } from '../../../types/menu';

export default class BasketHelpers {
  public static toggleModifier(
    lineItemModifiers: Server.OrderLineItemModifier[],
    modifierGroup: ClientMenu.ModifierGroup,
    modifier: ClientMenu.Modifier,
  ): Server.OrderLineItemModifier[] {
    if (modifierGroup.max_count === 1) {
      return collect(lineItemModifiers)
        .reject((item) => item.modifier_group_id === modifierGroup.id)
        .push({
          modifier_group_id: modifierGroup.id,
          modifier_id: modifier.id,
          modifier_type: 'modifier',
          quantity: 1,
        })
        .toArray();
    }

    const isAdded = !!collect(lineItemModifiers).first(
      (item) => item.modifier_group_id === modifierGroup.id && item.modifier_id === modifier.id,
    );

    if (isAdded || !modifierGroup.max_count) {
      return isAdded
        ? collect(lineItemModifiers)
            .reject(
              (item) =>
                item.modifier_group_id === modifierGroup.id && item.modifier_id === modifier.id,
            )
            .toArray()
        : [
            ...lineItemModifiers,
            {
              modifier_group_id: modifierGroup.id,
              modifier_id: modifier.id,
              modifier_type: 'modifier',
              quantity: 1,
            },
          ];
    }

    const selected = collect(lineItemModifiers)
      .where('modifier_group_id', modifierGroup.id)
      .count();
    if (selected >= modifierGroup.max_count) {
      return lineItemModifiers;
    }

    return [
      ...lineItemModifiers,
      {
        modifier_group_id: modifierGroup.id,
        modifier_id: modifier.id,
        modifier_type: 'modifier',
        quantity: 1,
      },
    ];
  }

  public static isModifierGroupRequired(modifierGroup: ClientMenu.ModifierGroup): boolean {
    return (
      modifierGroup.is_required && collect(modifierGroup.modifiers).firstWhere('is_available', true)
    );
  }
}
